
let completenessRating = {
    0: 'A1',
    1: 'A2',
    2: 'A3',
    3: 'B1',
    4: 'B2',
    5: 'B3',
    6: 'C1',
    7: 'C2',
    8: 'C3',
    9: 'D1',
    10: 'D2',
    11: 'D3',
    12: 'F1',
    13: 'F2',
    14: 'F3',
}

export default completenessRating;


// WEBPACK FOOTER //
// ./src/SectionTitle/components/completenessRating.js